export const PORTAL_ANALYTICS_MONTH_KEYS = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
];

export const portalAnalyticsTireTypes = [
  { id: "all", labelKey: "portalHome.analytics.tireTypes.all" },
  { id: "passenger", labelKey: "portalHome.analytics.tireTypes.passenger" },
  { id: "truck", labelKey: "portalHome.analytics.tireTypes.truck" },
];

const barSeries = (lastYear, thisYear) => ({ lastYear, thisYear });

const inchSlices = (values) => [
  { labelKey: "portalHome.analytics.inch.20", value: values[0], color: "#4a4a4a" },
  { labelKey: "portalHome.analytics.inch.19", value: values[1], color: "#636466" },
  { labelKey: "portalHome.analytics.inch.18", value: values[2], color: "#7a7a7a" },
  { labelKey: "portalHome.analytics.inch.17", value: values[3], color: "#9a9a9a" },
  { labelKey: "portalHome.analytics.inch.16", value: values[4], color: "#b5b5b5" },
  { labelKey: "portalHome.analytics.inch.15", value: values[5], color: "#cbcbcb" },
];

const supplierSlices = (interCars, handlopex, latex) => [
  {
    labelKey: "portalHome.analytics.suppliers.interCars",
    value: interCars,
    color: "#4a4a4a",
  },
  {
    labelKey: "portalHome.analytics.suppliers.handlopex",
    value: handlopex,
    color: "#7a7a7a",
  },
  {
    labelKey: "portalHome.analytics.suppliers.latex",
    value: latex,
    color: "#b5b5b5",
  },
];

export const portalAnalytics = {
  pointsVsLastYear: {
    id: "points",
    titleKey: "portalHome.analytics.pointsVsLastYear.title",
    thisYearColor: "#ed1c24",
    byTireType: {
      all: barSeries(
        [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20],
        [24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24],
      ),
      passenger: barSeries(
        [18, 19, 21, 22, 24, 26, 28, 27, 25, 23, 21, 19],
        [22, 24, 26, 28, 30, 32, 34, 33, 31, 28, 25, 23],
      ),
      truck: barSeries(
        [12, 12, 13, 14, 14, 15, 16, 15, 14, 13, 12, 11],
        [14, 15, 16, 17, 18, 19, 20, 19, 18, 16, 15, 14],
      ),
    },
  },
  tiresVsLastYear: {
    id: "tires",
    titleKey: "portalHome.analytics.tiresVsLastYear.title",
    thisYearColor: "#4a4a4a",
    byTireType: {
      all: barSeries(
        [320, 310, 340, 355, 370, 390, 410, 400, 385, 360, 330, 300],
        [350, 340, 375, 390, 405, 425, 445, 435, 420, 395, 365, 335],
      ),
      passenger: barSeries(
        [240, 235, 255, 265, 275, 290, 305, 298, 285, 270, 250, 230],
        [265, 258, 280, 292, 302, 318, 332, 325, 312, 295, 275, 252],
      ),
      truck: barSeries(
        [80, 75, 85, 90, 95, 100, 105, 102, 100, 90, 80, 70],
        [85, 82, 95, 98, 103, 107, 113, 110, 108, 100, 90, 83],
      ),
    },
  },
  purchasesByInch: {
    id: "inch",
    titleKey: "portalHome.analytics.purchasesByInch.title",
    byTireType: {
      all: { slices: inchSlices([50, 18, 16, 10, 4, 2]) },
      passenger: { slices: inchSlices([12, 14, 28, 32, 10, 4]) },
      truck: { slices: inchSlices([42, 24, 18, 10, 4, 2]) },
    },
  },
  purchasesBySupplier: {
    id: "supplier",
    titleKey: "portalHome.analytics.purchasesBySupplier.title",
    byTireType: {
      all: { slices: supplierSlices(54, 36, 10) },
      passenger: { slices: supplierSlices(48, 42, 10) },
      truck: { slices: supplierSlices(62, 28, 10) },
    },
  },
};

export function getPortalAnalyticsBarSeries(config, tireTypeId = "all") {
  const bucket = config.byTireType?.[tireTypeId] ?? config.byTireType?.all;

  if (!bucket) {
    return {
      lastYear: Array(PORTAL_ANALYTICS_MONTH_KEYS.length).fill(0),
      thisYear: Array(PORTAL_ANALYTICS_MONTH_KEYS.length).fill(0),
    };
  }

  return {
    lastYear: bucket.lastYear ?? [],
    thisYear: bucket.thisYear ?? [],
  };
}

export function getPortalAnalyticsPieSlices(config, tireTypeId = "all") {
  const bucket = config.byTireType?.[tireTypeId] ?? config.byTireType?.all;
  return bucket?.slices ?? [];
}
